// Mock data for City Central Pharmacy

export const branches = [
  {
    id: 1,
    name: "City Central Pharmacy, Ashiyie",
    address: "Adenta - Dodowa Rd, Accra, Ghana",
    phone: "+233 53 241 1752",
    hours: "Open 24 hours",
    is24Hours: true,
    coordinates: { lat: 5.7444105, lng: -0.1526035 },
    mapUrl: "https://maps.app.goo.gl/dLm2FTV78JdTNkAu8",
    directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=5.7444105,-0.1526035&travelmode=driving",
    mapEmbedUrl: "https://maps.google.com/maps?q=5.7444105,-0.1526035&hl=en&z=17&output=embed",
    image: "https://lh3.googleusercontent.com/p/AF1QipMEE-i19bOWg767jciafCertxM1VWsqGWgAQF1L=w408-h272-k-no"
  },
  {
    id: 2,
    name: "City Central Pharmacy, Mataheko",
    address: "Beside Ammeter Ventures, Afienya, Ghana",
    phone: "+233 59 497 0776",
    hours: "Open 24 hours",
    is24Hours: true,
    coordinates: { lat: 5.7619905, lng: -0.0031179 },
    mapUrl: "https://maps.app.goo.gl/XhLdQCBTJQXudqJm9",
    directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=5.7619905,-0.0031179&travelmode=driving",
    mapEmbedUrl: "https://maps.google.com/maps?q=5.7619905,-0.0031179&hl=en&z=17&output=embed",
    image: "https://lh3.googleusercontent.com/gps-cs-s/AG0ilSxv0eQoSTQpt4o_kJNMLhiES4dK6ce0cJ8SeMaiMrMd1bNjvans4c3-xQIKkghxQyU3ztWNEeT-PsQRH_SrKoBqr2v0MhoZUhfhcvrJ3e4Fu07cJ7r93KldoDiKDpKa69W2khkJbQ=w408-h272-k-no"
  },
  {
    id: 3,
    name: "City Central Pharmacy, Afienya",
    address: "Off Tema - Akosombo Rd, Afienya, Ghana",
    phone: "+233 55 150 3137",
    hours: "6:30 AM–10 PM",
    is24Hours: false,
    coordinates: { lat: 5.79433, lng: 0.00311 },
    mapUrl: "https://maps.app.goo.gl/jJz2bxZDJM2fro7q9",
    directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=5.79433,0.00311&travelmode=driving",
    mapEmbedUrl: "https://maps.google.com/maps?q=5.79433,0.00311&hl=en&z=17&output=embed",
    image: "https://customer-assets.emergentagent.com/job_189a4100-90ea-4234-8592-108cc00e468b/artifacts/hm5w18fs_IMG_0135.jpeg"
  },
  {
    id: 4,
    name: "City Central Pharmacy, Golf City",
    address: "Golf City Main St, Tema, Ghana",
    phone: "+233 54 290 0058",
    hours: "Open 24 hours",
    is24Hours: true,
    coordinates: { lat: 5.7141671, lng: -0.0058826 },
    mapUrl: "https://maps.app.goo.gl/GFYZ1An6rHdkmP8p8",
    directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=5.7141671,-0.0058826&travelmode=driving",
    mapEmbedUrl: "https://maps.google.com/maps?q=5.7141671,-0.0058826&hl=en&z=17&output=embed",
    image: "https://lh3.googleusercontent.com/p/AF1QipP0hR2qmTtS5ifKR2S_tcvsz7sjg1FN4qL3l5vX=w408-h272-k-no"
  },
  {
    id: 5,
    name: "City Central Pharmacy, Okpoi Gonno",
    address: "Market High St, Spintex, Ghana",
    phone: "+233 54 289 9556",
    hours: "6:30 AM–10 PM",
    is24Hours: false,
    coordinates: { lat: 5.6208243, lng: -0.1140881 },
    mapUrl: "https://maps.app.goo.gl/JjhPQhF1qNsZNJ3e7",
    directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=5.6208243,-0.1140881&travelmode=driving",
    mapEmbedUrl: "https://maps.google.com/maps?q=5.6208243,-0.1140881&hl=en&z=17&output=embed",
    image: "https://lh3.googleusercontent.com/p/AF1QipObro7P_GKbw_LQyhG-bq1WL-vqsS5YlnBvD7l2=w408-h272-k-no"
  }
];

// Calculate distance between two coordinates using Haversine formula
export const calculateDistance = (lat1, lng1, lat2, lng2) => {
  const R = 6371; // Earth's radius in km
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = 
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in km
};

// Find the nearest 24-hour branch from user's location
export const findNearest24HourBranch = (userLat, userLng) => {
  const branches24Hour = branches.filter(b => b.is24Hours);
  
  let nearest = null;
  let shortestDistance = Infinity;
  
  branches24Hour.forEach(branch => {
    const distance = calculateDistance(
      userLat, userLng,
      branch.coordinates.lat, branch.coordinates.lng
    );
    if (distance < shortestDistance) {
      shortestDistance = distance;
      nearest = { ...branch, distance: distance.toFixed(1) };
    }
  });
  
  return nearest;
};

// Find the nearest branch (any branch) from user's location
export const findNearestBranch = (userLat, userLng) => {
  let nearest = null;
  let shortestDistance = Infinity;
  
  branches.forEach(branch => {
    const distance = calculateDistance(
      userLat, userLng,
      branch.coordinates.lat, branch.coordinates.lng
    );
    if (distance < shortestDistance) {
      shortestDistance = distance;
      nearest = { ...branch, distance: distance.toFixed(1) };
    }
  });
  
  return nearest;
};

export const services = [
  {
    id: 1,
    title: "Prescription Dispensing",
    description: "Professional dispensing of prescription medicines by qualified pharmacists",
    icon: "Pill"
  },
  {
    id: 2,
    title: "Over-the-Counter Medicines",
    description: "Wide range of OTC medications for common ailments",
    icon: "ShoppingBag"
  },
  {
    id: 3,
    title: "Home & Office Delivery",
    description: "Fast and reliable delivery service to your doorstep",
    icon: "Truck"
  },
  {
    id: 4,
    title: "24-Hour Service",
    description: "Round-the-clock pharmaceutical services at select locations",
    icon: "Clock"
  },
  {
    id: 5,
    title: "Health Consultation",
    description: "Professional health advice and patient counselling",
    icon: "HeartPulse"
  },
  {
    id: 6,
    title: "In-Store Shopping",
    description: "Browse our extensive range of healthcare products",
    icon: "Store"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Kwame A.",
    rating: 5,
    comment: "The pharmacists are amazing. Always professional and helpful.",
    date: "2 weeks ago"
  },
  {
    id: 2,
    name: "Ama D.",
    rating: 5,
    comment: "City Central has mostly all drugs and health needs. Very reliable!",
    date: "1 month ago"
  },
  {
    id: 3,
    name: "Kofi M.",
    rating: 5,
    comment: "Great service and they're open 24 hours. Very convenient.",
    date: "3 weeks ago"
  }
];

export const products = [
  {
    id: 1,
    name: "Paracetamol 500mg",
    category: "Pain Relief",
    price: 15.00,
    image: "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400",
    description: "Effective pain and fever relief",
    inStock: true,
    prescription: false
  },
  {
    id: 2,
    name: "Vitamin C Tablets",
    category: "Supplements",
    price: 35.00,
    image: "https://images.unsplash.com/photo-1550572017-edd951aa8f6a?w=400",
    description: "Boost your immune system",
    inStock: true,
    prescription: false
  },
  {
    id: 3,
    name: "Amoxicillin 250mg",
    category: "Antibiotics",
    price: 45.00,
    image: "https://images.unsplash.com/photo-1471864190281-a93a3070b6de?w=400",
    description: "Antibiotic for bacterial infections",
    inStock: true,
    prescription: true
  },
  {
    id: 4,
    name: "Blood Pressure Monitor",
    category: "Medical Devices",
    price: 250.00,
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=400",
    description: "Digital BP monitoring device",
    inStock: true,
    prescription: false
  },
  {
    id: 5,
    name: "Hand Sanitizer 500ml",
    category: "Hygiene",
    price: 25.00,
    image: "https://images.unsplash.com/photo-1584483766114-2cea6facdf57?w=400",
    description: "70% alcohol-based sanitizer",
    inStock: true,
    prescription: false
  },
  {
    id: 6,
    name: "First Aid Kit",
    category: "Emergency",
    price: 80.00,
    image: "https://images.unsplash.com/photo-1603398938378-e54eab446dde?w=400",
    description: "Complete first aid essentials",
    inStock: true,
    prescription: false
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "10 Essential Tips for Managing Diabetes",
    excerpt: "Learn how to effectively manage your diabetes with these practical tips from our expert pharmacists.",
    author: "Dr. Mensah",
    date: "2025-03-15",
    category: "Chronic Conditions",
    image: "https://images.unsplash.com/photo-1579154204601-01588f351e67?w=800",
    readTime: "5 min read"
  },
  {
    id: 2,
    title: "The Importance of Regular Health Check-ups",
    excerpt: "Discover why routine health screenings are crucial for early detection and prevention of diseases.",
    author: "Pharmacist Ama",
    date: "2025-03-10",
    category: "Preventive Care",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800",
    readTime: "4 min read"
  },
  {
    id: 3,
    title: "Understanding Your Prescription Medications",
    excerpt: "A comprehensive guide to understanding what your doctor prescribes and how to take medications safely.",
    author: "Dr. Boateng",
    date: "2025-03-05",
    category: "Medication Safety",
    image: "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?w=800",
    readTime: "6 min read"
  }
];